var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMinScreenTemp01 = function SvgMinScreenTemp01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "min_screen_temp-01_svg2__a",
    x1: 12.83,
    x2: 161.72,
    y1: 169.75,
    y2: 4.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#min_screen_temp-01_svg2__a",
    id: "min_screen_temp-01_svg2__b",
    x1: -6.83,
    x2: 142.06,
    y1: 152.06,
    y2: -13.4
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#min_screen_temp-01_svg2__a",
    id: "min_screen_temp-01_svg2__c",
    x1: -37.34,
    x2: 111.56,
    y1: 124.61,
    y2: -40.85
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#min_screen_temp-01_svg2__a",
    id: "min_screen_temp-01_svg2__d",
    x1: -25.78,
    x2: 123.11,
    y1: 135,
    y2: -30.45
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#min_screen_temp-01_svg2__a",
    id: "min_screen_temp-01_svg2__e",
    x1: 3.39,
    x2: 152.28,
    y1: 161.26,
    y2: -4.2
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#min_screen_temp-01_svg2__a",
    id: "min_screen_temp-01_svg2__f",
    x1: 7.92,
    x2: 156.82,
    y1: 165.34,
    y2: -0.12
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#min_screen_temp-01_svg2__a",
    id: "min_screen_temp-01_svg2__g",
    x1: -22.64,
    x2: 126.26,
    y1: 137.84,
    y2: -27.62
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#min_screen_temp-01_svg2__a",
    id: "min_screen_temp-01_svg2__h",
    x1: 48.97,
    x2: 197.86,
    y1: 202.27,
    y2: 36.81
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#min_screen_temp-01_svg2__a",
    id: "min_screen_temp-01_svg2__i",
    x1: 37.98,
    x2: 186.87,
    y1: 192.38,
    y2: 26.93
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#min_screen_temp-01_svg2__a",
    id: "min_screen_temp-01_svg2__j",
    x1: 57.98,
    x2: 206.87,
    y1: 210.38,
    y2: 44.92
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#min_screen_temp-01_svg2__a",
    id: "min_screen_temp-01_svg2__k",
    x1: 54.97,
    x2: 203.87,
    y1: 207.68,
    y2: 42.22
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#min_screen_temp-01_svg2__a",
    id: "min_screen_temp-01_svg2__l",
    x1: 70.5,
    x2: 219.4,
    y1: 221.65,
    y2: 56.19
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#min_screen_temp-01_svg2__a",
    id: "min_screen_temp-01_svg2__m",
    x1: 84.64,
    x2: 233.53,
    y1: 234.37,
    y2: 68.91
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M160.88 15.21c.87-.9.85-2.34-.05-3.22-.9-.87-2.35-.85-3.22.05L39.25 130.4a2.279 2.279 0 1 0 3.22 3.22L160.83 15.27l.05-.05",
    style: {
      fill: "url(#min_screen_temp-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.55 95.7c.42.43 1.01.68 1.61.68a2.33 2.33 0 0 0 1.58-.66c.9-.88.91-2.32.03-3.22a37.28 37.28 0 0 1-10.72-26.49c0-20.08 15.32-36.42 34.14-36.42a33.27 33.27 0 0 1 25.99 12.8 2.279 2.279 0 0 0 3.56-2.84c-7.11-9.1-18-14.44-29.55-14.51-21.34 0-38.69 18.38-38.69 40.97A41.78 41.78 0 0 0 66.54 95.7",
    style: {
      fill: "url(#min_screen_temp-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.18 31.2c.43.43 1.01.67 1.61.67s1.18-.24 1.61-.67c.89-.89.89-2.33 0-3.22l-9.1-9.1c-.88-.85-2.28-.85-3.16 0-.9.87-.93 2.31-.05 3.22l9.1 9.1Z",
    style: {
      fill: "url(#min_screen_temp-01_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.41 66.01c0-1.26-1.02-2.28-2.28-2.28H29.47a2.279 2.279 0 1 0 0 4.56h13.66c1.26 0 2.28-1.02 2.28-2.28",
    style: {
      fill: "url(#min_screen_temp-01_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.68 113.81c.6 0 1.18-.24 1.61-.67l9.1-9.11c.85-.88.85-2.28 0-3.16-.87-.9-2.31-.93-3.22-.06l-9.1 9.1a2.279 2.279 0 0 0 1.61 3.89",
    style: {
      fill: "url(#min_screen_temp-01_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.62 31.87c.6 0 1.18-.24 1.61-.67l9.1-9.11c.85-.88.85-2.28 0-3.16-.87-.9-2.31-.93-3.22-.06l-9.1 9.1a2.279 2.279 0 0 0 1.61 3.89",
    style: {
      fill: "url(#min_screen_temp-01_svg2__f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.21 18.21c1.26 0 2.28-1.02 2.28-2.28V2.28C95.48 1.02 94.46 0 93.21 0s-2.28 1.02-2.28 2.28v13.66c0 1.26 1.02 2.28 2.28 2.28",
    style: {
      fill: "url(#min_screen_temp-01_svg2__g)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.39 112.81a2.277 2.277 0 0 0-3.17-.56 30.2 30.2 0 0 1-17.46 5.49c-16.47.11-29.93-13.12-30.08-29.59 0-4.98 1.27-9.87 3.68-14.21.3-.55.37-1.19.18-1.78a2.27 2.27 0 0 0-2.85-1.49c-16.34 4.99-27.4 20.19-27.13 37.27.34 21.18 17.77 38.07 38.95 37.73 18.55.08 34.57-12.95 38.26-31.13.12-.61-.01-1.23-.37-1.74m-37.16 28.32c-19.05.36-34.78-14.79-35.14-33.84.01-12.87 7.35-24.6 18.91-30.25a33.7 33.7 0 0 0-1.88 11.13c.16 18.98 15.65 34.26 34.64 34.14a34.7 34.7 0 0 0 15.06-3.39c-5.01 13.15-17.51 21.93-31.58 22.2",
    style: {
      fill: "url(#min_screen_temp-01_svg2__h)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.56 79.67c1.26 0 2.28-1.02 2.28-2.28v-2.28h2.28a2.279 2.279 0 1 0 0-4.56h-2.28v-2.28a2.279 2.279 0 1 0-4.56 0v2.28H141a2.279 2.279 0 1 0 0 4.56h2.28v2.28c0 1.26 1.02 2.28 2.28 2.28",
    style: {
      fill: "url(#min_screen_temp-01_svg2__i)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.49 91.05a2.279 2.279 0 1 0-4.56 0v4.55h-4.55a2.279 2.279 0 1 0 0 4.56h4.55v4.55a2.279 2.279 0 1 0 4.56 0v-4.55h4.55a2.279 2.279 0 1 0 0-4.56h-4.55z",
    style: {
      fill: "url(#min_screen_temp-01_svg2__j)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m52.98 200 7.19-37h6.16l8.59 22.65L83.53 163h6.16l7.19 37h-7.45l-4.1-21.22-7.9 20.85h-5.02l-7.88-20.85L60.41 200z",
    style: {
      fill: "url(#min_screen_temp-01_svg2__k)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.99 163h7.29v37h-7.29z",
    style: {
      fill: "url(#min_screen_temp-01_svg2__l)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.42 200v-37h7.87l14.43 23.81V163h7.3v37h-7.88l-14.43-23.81V200z",
    style: {
      fill: "url(#min_screen_temp-01_svg2__m)"
    }
  }));
};
export default SvgMinScreenTemp01;